import React, {useState} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {DNA} from "@dna/react";
import {HeaderCell} from "../common/material-table";
import {ContentRow} from "./pharmacy-medications-table/ContentRow";
import {Backdrop, CircularProgress} from "@material-ui/core";
import {
    GroupedResidentPharmacyMedications,
    SelectableMedication
} from "./usePharmacyMedications";


const useStyles = makeStyles({
    tableRowGroupHeader:{
        backgroundColor: DNA.tokens.color.gray["100"],
        "& td":{
            fontWeight: 600,
            fontSize: "12px",
            textTransform: "uppercase",
            color:"#414141",
            lineHeight:"16px",
            letterSpacing:"0.2em",
            padding: "12px 16px 12px 16px"
        }   
    },
    countMed:{
        color:"#006AD2"
    }
});

const LimitedBackdrop = withStyles({
    root: {
        position: "absolute",
        zIndex: 1
    }
})(Backdrop);

const formatData = (data: SelectableMedication[])=>{
    return new GroupedResidentPharmacyMedications(data);
}


export const PharmacyRequestList = (props:{
    medicationorderId?:string;
    data:SelectableMedication[];
    onMedicationActioned:(authoringSystem:string,authoringSystemForeignKey:string)=>void;
    onRowSelected:(authoringSystem:string,authoringSystemForeignKey:string,encounterAuthoringSystem:string,encounterAuthoringSystemForeignKey:string)=>void;
})=> {
    const classes = useStyles();
    
    let rows = formatData(props.data||[]);
    
    const createContentRow = (row:SelectableMedication)=>{
        return <ContentRow
            item={row}
            key={`${row.authoringSystem}_${row.authoringSystemForeignKey}`}
            onActioned={props.onMedicationActioned}
            onRowSelected={(authoringSystem,authoringSystemForeignKey)=>props.onRowSelected(authoringSystem,authoringSystemForeignKey,row.encounterAuthoringSystem,row.encounterAuthoringSystemForeignKey)}
        />
    }
    return (
        
            <TableContainer>
                <Table aria-label="sticky table">
                    <TableHead>
                        <TableRow role="header">
                            <HeaderCell key={1}>
                                Product
                            </HeaderCell>
                            <HeaderCell key={2}>
                                Order instructions
                            </HeaderCell>
                            <HeaderCell key={3}>
                                Script no.
                            </HeaderCell>
                            <HeaderCell key={4}>
                                Start date
                            </HeaderCell>
                            <HeaderCell key={5}>
                                End date
                            </HeaderCell>
                            <HeaderCell key={6}>
                                Prescribed by
                            </HeaderCell>
                            <HeaderCell key={7}>
                                Status
                            </HeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows.regular.count?
                                <>
                                    <TableRow className={classes.tableRowGroupHeader}>
                                        <TableCell colSpan={7}>Regular (<span className={classes.countMed}>{rows.regular.count}</span>)</TableCell>
                                    </TableRow>
                                    {rows.regular.data.map(row=>{
                                        return createContentRow(row);
                                    })}
                                </>:null
                        }
                        {
                            rows.shortCourse.count?
                                <>
                                    <TableRow className={classes.tableRowGroupHeader}>
                                        <TableCell colSpan={7}>short course (<span className={classes.countMed}>{rows.shortCourse.count}</span>)</TableCell>
                                    </TableRow>
                                    {rows.shortCourse.data.map(row=>{
                                        return createContentRow(row);
                                    })}
                                </>:null
                        }

                        {
                            rows.prn.count?
                                <>
                                    <TableRow className={classes.tableRowGroupHeader}>
                                        <TableCell colSpan={7}>prn (<span className={classes.countMed}>{rows.prn.count}</span>)</TableCell>
                                    </TableRow>
                                    {rows.prn.data.map(row=>{
                                        return createContentRow(row);
                                    })}
                                </>:null
                        }
                        {
                            rows.ceasedConfirmed.count?
                                <>
                                    <TableRow className={classes.tableRowGroupHeader}>
                                        <TableCell colSpan={7}>ceased medication (<span className={classes.countMed}>{rows.ceasedConfirmed.count}</span>)</TableCell>
                                    </TableRow>
                                    {rows.ceasedConfirmed.data.map(row=>{
                                        return createContentRow(row);
                                    })}
                                </>:null
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        
        
    );
}
